module.exports = __webpack_public_path__ + "static/media/distortion1.b8da763a.jpg";